import x from "./AddVideos";
export default x;
